module.exports = __webpack_public_path__ + "img/YOUZAN.6dff5040.svg";